import React, { Component, lazy, Suspense } from 'react'
import './index.scss'
import classNames from 'classnames'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { string } from 'prop-types'

import { PROVIDERS } from 'consts'

const ReactPlayer = lazy(() => import(/* webpackChunkName: "reactPlayer" */ 'react-player'))

@observer
class Player extends Component {
  @observable
  playing = false

  @observable
  error = false

  constructor(props) {
    super(props)
    this.playerContainer = null
    this.videoElement = null
    this.playingTimeout = null
  }

  componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.playing = false
      this.error = false
    }
  }

  componentWillUnmount() {
    clearTimeout(this.playingTimeout)
  }

  onPlay = () => (this.playing = true)

  onPause = () => (this.playing = false)

  onError = () => {
    const { url } = this.props
    if (!url) {
      this.error = true
    }
  }

  render() {
    const { url, provider, className, playerClassName, wrapperClassName, ...props } = this.props

    const playerClass = classNames('react-player', playerClassName, {
      youtube: provider === PROVIDERS['yt'].KEY,
      facebook: provider === PROVIDERS['fb'].KEY,
      instagram: provider === PROVIDERS['in'].KEY,
      tiktok: provider === PROVIDERS['tt'].KEY,
    })

    const wrapperClass = classNames('player-wrapper', wrapperClassName)

    const containerClass = classNames('player-component', className)

    return (
      <div className={containerClass}>
        <div className={wrapperClass}>
          {this.error && <div className="player-error">Video could not be played.</div>}
          {!this.error && (
            <Suspense fallback={null}>
              <ReactPlayer
                ref={r => (this.playerContainer = r)}
                url={url}
                className={playerClass}
                controls
                playing={this.playing}
                width="100%"
                height="100%"
                onPlay={this.onPlay}
                onPause={this.onPause}
                onError={this.onError}
                config={{
                  facebook: { appId: '542864969138098' },
                }}
                {...props}
              />
            </Suspense>
          )}
        </div>
      </div>
    )
  }
}

Player.propTypes = {
  url: string,
  provider: string,
}

Player.displayName = 'Player'

export default Player
